import { render, staticRenderFns } from "./pwdRecovery.vue?vue&type=template&id=1ef2d130&scoped=true"
import script from "./pwdRecovery.vue?vue&type=script&lang=js"
export * from "./pwdRecovery.vue?vue&type=script&lang=js"
import style0 from "./pwdRecovery.vue?vue&type=style&index=0&id=1ef2d130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2d130",
  null
  
)

export default component.exports